import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Insight, MotionData, Value } from '../../types';

/**
 * Service for metrics-related API calls
 */
export const metricsService = {
  /**
   * Get metrics for a device
   * @param deviceId - The device ID
   * @param from - Optional date to filter metrics from
   */
  getMetrics: (deviceId: string, from?: Date): Promise<AxiosResponse<Record<string, Value[]>>> => {
    const params = from ? { from } : {};
    return apiClient.get(`/api/devices/${deviceId}/metrics`, { params });
  },

  /**
   * Get activity data for a device
   * @param deviceId - The device ID
   * @param from - Optional date to filter activity from
   */
  getActivity: (deviceId: string, from?: Date): Promise<AxiosResponse<Record<string, Value[]>>> => {
    const params = from ? { from } : {};
    return apiClient.get(`/api/devices/${deviceId}/activity`, { params });
  },

  /**
   * Get motion data for a device
   * @param deviceId - The device ID
   * @param from - Optional date to filter motion data from
   */
  getMotionData: (deviceId: string, from?: Date): Promise<AxiosResponse<MotionData>> => {
    const params = from ? { from } : {};
    return apiClient.get(`/api/devices/${deviceId}/motion`, { params });
  },

  /**
   * Get insights for a device
   * @param deviceId - The device ID
   * @param from - Optional date to filter insights from
   */
  getInsights: (deviceId: string, from?: Date): Promise<AxiosResponse<Insight[]>> => {
    const params = from ? { from } : {};
    return apiClient.get(`/api/devices/${deviceId}/insights`, { params });
  },

  /**
   * Get vitals for a device
   * @param deviceId - The device ID
   * @param from - Optional date to filter vitals from
   */
  getVitals: (deviceId: string, from?: Date): Promise<AxiosResponse<Value>> => {
    const params = from ? { from } : {};
    return apiClient.get(`/api/devices/${deviceId}/vitals`, { params });
  },
};
